// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-nav {
  width: 240px;
  min-width: 240px;
  max-width: 240px;
  height: 100%;
  background-color: var(--neutral-100);
  border-right: 1px solid var(--neutral-300);
  flex-shrink: 0;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}

.project-nav-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  padding-top: 8px;
}

.project-nav-link {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  width: 224px;
  height: 48px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: -0.3px;
  line-height: 1.5;
  color: var(--neutral-800);
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.project-nav-link:hover {
  background-color: var(--neutral-200);
  color: var(--neutral-800);
  text-decoration: none;
}

.project-nav-link.project-nav-link-active,
.project-nav-link.project-nav-link-active:hover {
  background-color: var(--blue-200);
  color: var(--neutral-950);
}

.project-nav-link.project-nav-link-disabled {
  pointer-events: none;
  opacity: 0.5;
}

.project-nav-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: none;
  border-bottom: 1px solid var(--neutral-200);
  background: transparent;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.26px;
  line-height: 1.5;
  color: var(--neutral-600);
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.15s ease;
}

.project-nav-section-header:hover {
  color: var(--neutral-800);
}

.project-nav-section-header .caret-icon {
  display: flex;
  align-items: center;
}

.project-nav-section-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  padding-top: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/projects/ProjectNav.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,2CAA2C;EAC3C,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB","sourcesContent":[".project-nav {\n  width: 240px;\n  min-width: 240px;\n  max-width: 240px;\n  height: 100%;\n  background-color: var(--neutral-100);\n  border-right: 1px solid var(--neutral-300);\n  flex-shrink: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: relative;\n}\n\n.project-nav-list {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1px;\n  padding-top: 8px;\n}\n\n.project-nav-link {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  width: 224px;\n  height: 48px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 500;\n  letter-spacing: -0.3px;\n  line-height: 1.5;\n  color: var(--neutral-800);\n  text-decoration: none;\n  white-space: nowrap;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.project-nav-link:hover {\n  background-color: var(--neutral-200);\n  color: var(--neutral-800);\n  text-decoration: none;\n}\n\n.project-nav-link.project-nav-link-active,\n.project-nav-link.project-nav-link-active:hover {\n  background-color: var(--blue-200);\n  color: var(--neutral-950);\n}\n\n.project-nav-link.project-nav-link-disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n\n.project-nav-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  width: 100%;\n  height: 48px;\n  padding: 0 16px;\n  border: none;\n  border-bottom: 1px solid var(--neutral-200);\n  background: transparent;\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: -0.26px;\n  line-height: 1.5;\n  color: var(--neutral-600);\n  text-align: left;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.project-nav-section-header:hover {\n  color: var(--neutral-800);\n}\n\n.project-nav-section-header .caret-icon {\n  display: flex;\n  align-items: center;\n}\n\n.project-nav-section-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1px;\n  padding-top: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
